(function () {
  "use strict";

  const STORAGE_PREFIX = "worksafe_alert_";
  const prefersReducedMotion = () =>
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const dismissAlert = (alert) => {
    if (prefersReducedMotion() || alert.classList.contains("is-dismissing")) {
      alert.classList.add("hide");
      return;
    }

    const finish = (event) => {
      if (event.target !== alert || event.propertyName !== "grid-template-rows") {
        return;
      }

      alert.removeEventListener("transitionend", finish);
      alert.classList.add("hide");
      alert.classList.remove("is-dismissing");
    };

    alert.addEventListener("transitionend", finish);
    alert.classList.add("is-dismissing");
  };

  document.addEventListener("DOMContentLoaded", () => {
    const alerts = document.querySelectorAll(".alerts .alert[data-alert-id]");

    if (alerts.length === 0) return;

    alerts.forEach((alert) => {
      const alertId = alert.getAttribute("data-alert-id");
      const storageKey = `${STORAGE_PREFIX}${alertId}_dismissed`;

      if (localStorage.getItem(storageKey) !== "true") {
        alert.classList.remove("hide");
      }

      const closeButton = alert.querySelector(".js-alert-close");
      if (!closeButton) return;

      closeButton.addEventListener("click", () => {
        localStorage.setItem(storageKey, "true");
        dismissAlert(alert);
      });
    });
  });
})();
